<div
	class="order-card"
	[class.red]="orderValue?._id === selectedRed?.id && selectedRed?.error"
	[class.orange]="orderValue?._id === selectedRed?.id && selectedRed?.warning"
>
	<div class="order-header" *ngIf="orderValue">
		<app-order-item-header-info
			[orderValue]="orderValue"
			[venue]="venue"
		></app-order-item-header-info>
	</div>
	<ng-container *ngIf="checkIfOrder(orderValue) as orderItemValue">
		<app-order-item-checkout-integration-info
			[loading]="loadingOrders.includes(orderValue._id)"
			(sendOrderToPOS)="sendToPos(orderValue)"
			[order]="orderValue"
		></app-order-item-checkout-integration-info>
	</ng-container>

	<app-order-item-status-section
		[orderValue]="orderValue"
		[updateStatusLoading]="updateStatusLoading"
		(sendStatusOrderPool)="sendStatusOrderPoolFunc($event)"
		(emitSelectOrderToShow)="emitSelectOrderToShow($event)"
		(sendOrderStatusChange)="updateStatus($event)"
	></app-order-item-status-section>
	@if (checkIfOrder(orderValue)) {
	<div class="order-details">
		<div class="order-item" *ngFor="let item of orderValue.orderedArticles">
			<app-order-item-articlegroup-draw
				[articleGroup]="item"
				[orderStatus]="orderValue.status"
			></app-order-item-articlegroup-draw>
		</div>
	</div>
	<div *ngIf="(printerConnected | async) && orderValue && venue">
		<button class="print" (click)="printOrder(orderValue, venue)">Print</button>
	</div>
	} @if (checkIfOrderPool(orderValue)) {
	<div class="order-pool-details">
		@for (orderFoodSpot of orderValue.orders; track orderFoodSpot._id) {
		<div [id]="'order-' + orderFoodSpot._id">
			<div class="order-title">
				<p [class.selected]="selectedOrderId === orderFoodSpot?._id">
					{{ orderFoodSpot.code }}
				</p>
			</div>
			<div
				class="order-item"
				*ngFor="let item of orderFoodSpot.orderedArticles"
			>
				<app-order-item-articlegroup-draw
					[articleGroup]="item"
					[orderStatus]="orderValue.orderStatus"
				></app-order-item-articlegroup-draw>
			</div>
		</div>
		}
	</div>
	}
</div>
